import dateToObj from './dateToObj'

export default function (timestamp, year, second) {
  if (!timestamp) return ''
  let time = dateToObj(timestamp)
  // console.log('time', time);
  // 只返回yyyy-MM-dd
  if (year && !second) return `${time.y}-${time.m}-${time.d}`
  // 计算时差 返回dd:hh:mm:ss
  if(!year && second) return `${time.d}:${time.hh}:${time.mm}:${time.ss}`
  // 返回yyyy-MM-dd hh:mm:ss
  return `${time.m}月${time.d}日 ${time.hh}:${time.mm}`
}
